import { render, staticRenderFns } from "./market-item-orders-cards.vue?vue&type=template&id=06d5c85a&scoped=true"
import script from "./market-item-orders-cards.vue?vue&type=script&lang=js"
export * from "./market-item-orders-cards.vue?vue&type=script&lang=js"
import style0 from "./market-item-orders-cards.vue?vue&type=style&index=0&id=06d5c85a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d5c85a",
  null
  
)

export default component.exports